import React from 'react';

import TimeFormat from '@scripts/utilities/time-format.js';

import Analytics from '../Analytics/index.jsx';
import BackgroundImage from '../BackgroundImage/index.jsx';
import CMSContent from '../CMSContent/index.jsx';
import ResponsiveEmbed from '../ResponsiveEmbed/index.jsx';

import ResourcesIcon from './icons/Resources.jsx';
import DailySnapshotIcon from './icons/DailySnapshot.jsx';
import ResearchReportIcon from './icons/ResearchReport.jsx';


class ArticleRender extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDetails: false
    }
  }
  
  render() {
    var article = this.props.article;

    var articleType = article.type;
    var articleIcon = null
    var articleContent = null
    var articleTitle = null
    var articleDirection = 'normal'

    var title;
    var image;
    var content;

    var previewEmbed = article.embed;
    if (previewEmbed) {
      previewEmbed = (
        <div key="embed" className="my-3">
          <Analytics.VideoEmbeds eventProperties={article.analytics}>
            <ResponsiveEmbed embed={previewEmbed} />
          </Analytics.VideoEmbeds>
        </div>
      );
    }

    switch(articleType) {
      case 'Daily Snapshots':
        articleContent = article.excerpt;
        break;
      case 'Research Report':
        articleTitle = article.title
        if(! article.embed){
          articleDirection = 'reverse'
          articleIcon = <div className="cs-daily-posts-article__image-wrap"><img src={article.image}/></div>
        }
        articleContent = article.excerpt;
        break;
      case 'Resources':
        articleIcon = <div className="cs-daily-posts-article__image-wrap"><img className="resources-icon" src={article.image}/></div>
        articleDirection = 'reverse'
        articleTitle = article.title
        articleContent = article.excerpt;
        break;
      case 'Crypto Spotlight Report':
        articleTitle = article.title
        articleIcon = <div className="cs-daily-posts-article__image-wrap"><img src={article.image}/></div>
        articleContent = article.excerpt;
        break;
      default:
        articleContent = article.excerpt;
        articleTitle = article.title;
        break;
    }

    if (articleTitle) {
      title = (
        <h2
          key="title" className="cs-daily-posts-article__title"
          dangerouslySetInnerHTML={{ __html: articleTitle }}
        />
      );
    }
    if (articleIcon) {
      image = (
        <div key="image" className="cs-daily-posts-article__image">
          {articleIcon}
        </div>
      );
    }
    if (articleContent) {
      content = (
        <Analytics.All key="content" eventProperties={article.analytics}>
          <CMSContent content={articleContent} />
        </Analytics.All>
      );
    }

    var result = [];

    if (articleDirection == 'normal') {
      result.push(image);
      result.push(title);
    } else {
      result.push(title);
      result.push(image);
    }
    result.push(previewEmbed);
    result.push(content);


    return result;
  }
}


export default ArticleRender;

